const MATCHTYPE = [
  'UNSPECIFIED',
  'UNKNOWN',
  'EXACT',
  'PHRASE',
  'BROAD',
]

export default MATCHTYPE
